import React from 'react';
import { useIntl } from 'react-intl';
import { graphql, useStaticQuery } from 'gatsby';

import { link, row } from './EditLink.module.scss';

export type EditLinkProps = {
    repository?: {
        baseUrl?: string;
        branch?: string;
    };
    relativePagePath?: string;
};

export default function EditLink({ relativePagePath, repository: repositoryProp }: EditLinkProps) {
    const intl = useIntl();
    const data = useStaticQuery<Queries.EditLinkDataQuery>(graphql`
        query EditLinkData {
            site {
                siteMetadata {
                    repository {
                        baseUrl
                        branch
                    }
                }
            }
        }
    `);
    const { baseUrl, branch } = repositoryProp || data.site?.siteMetadata?.repository || {};

    const href = `${baseUrl}/edit/${branch}/src/pages${relativePagePath}`;

    return baseUrl ? (
        <div className={`cds--row ${row}`}>
            <div className="cds--col">
                {/* eslint-disable-next-line gatsby/use-gatsby-link */}
                <a className={link} href={href} children={intl.formatMessage({ defaultMessage: 'Edit this page' })} />
            </div>
        </div>
    ) : null;
}
